import { filter, map } from 'lodash'
import moment from 'moment'
moment.locale('pt')

const prepareLocks = schedules => {
  return filter(schedules, {lock: true})
}

const prepareSave = schedules => {
  const data = map(prepareLocks(schedules), schedule => {
    return {
      id: schedule.id
    }
  })

  return {
    schedules: data
  }
}

const prepareSchedule = schedule => {
  schedule.lock = false
  schedule.day = moment(schedule.date).format('dddd')
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = moment(schedule.date).format('DD/MM/YYYY')

  return {...schedule}
}

export default {
  doLocks () {
    const locks = prepareSave(this.schedules)
    this.$resource.put('', locks)
      .then(({data}) => {
        this.$emit('locked', true)
      })
  },
  setSchedules () {
    this.schedules = map(this.data, prepareSchedule)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/preview/resources/methods.js